import { useMemo } from 'react';
import VirtualScroller from '../VirtualScroller.js'; // Creates a `VirtualScroller` instance.

export default function useVirtualScroller(_ref, _ref2) {
  var items = _ref.items,
      estimatedItemHeight = _ref.estimatedItemHeight,
      getEstimatedItemHeight = _ref.getEstimatedItemHeight,
      getEstimatedVisibleItemRowsCount = _ref.getEstimatedVisibleItemRowsCount,
      getEstimatedInterItemVerticalSpacing = _ref.getEstimatedInterItemVerticalSpacing,
      bypass = _ref.bypass,
      onItemInitialRender = _ref.onItemInitialRender,
      onItemFirstRender = _ref.onItemFirstRender,
      initialScrollPosition = _ref.initialScrollPosition,
      onScrollPositionChange = _ref.onScrollPositionChange,
      measureItemsBatchSize = _ref.measureItemsBatchSize,
      scrollableContainer = _ref.scrollableContainer,
      getScrollableContainer = _ref.getScrollableContainer,
      getColumnsCount = _ref.getColumnsCount,
      getItemId = _ref.getItemId,
      initialState = _ref.initialState,
      getInitialItemState = _ref.getInitialItemState,
      onStateChange = _ref.onStateChange;
  var getItemsContainerElement = _ref2.getItemsContainerElement;
  return useMemo(function () {
    // Create `virtual-scroller` instance.
    return new VirtualScroller(getItemsContainerElement, items, {
      delayRecursiveRenderUntilNextTick: true,
      // `estimatedItemHeight` is deprecated, use `getEstimatedItemHeight()` instead.
      estimatedItemHeight: estimatedItemHeight,
      getEstimatedItemHeight: getEstimatedItemHeight,
      getEstimatedVisibleItemRowsCount: getEstimatedVisibleItemRowsCount,
      getEstimatedInterItemVerticalSpacing: getEstimatedInterItemVerticalSpacing,
      bypass: bypass,
      // bypassBatchSize,
      onItemInitialRender: onItemInitialRender,
      // `onItemFirstRender(i)` is deprecated, use `onItemInitialRender(item)` instead.
      onItemFirstRender: onItemFirstRender,
      initialScrollPosition: initialScrollPosition,
      onScrollPositionChange: onScrollPositionChange,
      measureItemsBatchSize: measureItemsBatchSize,
      // `scrollableContainer` property is deprecated.
      // Use `getScrollableContainer()` property instead.
      scrollableContainer: scrollableContainer,
      getScrollableContainer: getScrollableContainer,
      getColumnsCount: getColumnsCount,
      getItemId: getItemId,
      state: initialState,
      getInitialItemState: getInitialItemState,
      onStateChange: onStateChange
    });
  }, []);
}
//# sourceMappingURL=useCreateVirtualScroller.js.map